import { render } from "./CirclePage.vue?vue&type=template&id=b08c2532"
import script from "./CirclePage.vue?vue&type=script&lang=js"
export * from "./CirclePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__